export const stopEvent = e => {
  e.preventDefault();
  e.stopPropagation();
};